import { Injectable } from '@angular/core'
import { Cluster, clustersPath } from '@parkupp/core'
import { addDoc, collection, collectionData, doc, docData, Firestore, serverTimestamp, updateDoc } from '@angular/fire/firestore'
import { getDownloadURL, ref, Storage, uploadBytes } from '@angular/fire/storage'
import { firstValueFrom, Observable } from 'rxjs'

@Injectable({
    providedIn: 'root',
})
export class ClusterService {
    collection = collection(this.firestore, clustersPath())

    constructor(public firestore: Firestore, private storage: Storage) {}

    list(): Observable<Cluster[]> {
        return collectionData(this.collection, { idField: '$key' }) as Observable<Cluster[]>
    }

    async listPromise(): Promise<Cluster[]> {
        return firstValueFrom(this.list())
    }

    get(clusterKey: string): Observable<Cluster> {
        const clusterDocRef = doc(this.firestore, `${clustersPath()}/${clusterKey}`)
        return docData(clusterDocRef, { idField: '$key' }) as Observable<Cluster>
    }

    async getPromise(clusterKey: string): Promise<Cluster> {
        const clusterDocRef = doc(this.firestore, `${clustersPath()}/${clusterKey}`)
        const documentData = await firstValueFrom(docData(clusterDocRef, { idField: '$key' }))
        return new Cluster(documentData as any)
    }

    async create(cluster: Partial<Cluster>): Promise<string> {
        const clusterData = {
            ...cluster,
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp(),
        }

        const docRef = await addDoc(this.collection, clusterData)
        return docRef.id
    }

    async update(clusterKey: string, data: Partial<Cluster>): Promise<void> {
        const clusterDocRef = doc(this.firestore, `${clustersPath()}/${clusterKey}`)
        const updateData = {
            ...data,
            updatedAt: serverTimestamp(),
        }
        await updateDoc(clusterDocRef, updateData)
    }

    async uploadLogo(file: File, clusterKey: string): Promise<string> {
        const timestamp = new Date().getTime()
        const fileExtension = file.name.split('.').pop()
        const filePath = `clusters/${clusterKey}/logo_${timestamp}.${fileExtension}`
        const storageRef = ref(this.storage, filePath)

        await uploadBytes(storageRef, file)
        const downloadURL = await getDownloadURL(storageRef)
        return downloadURL
    }
}
